// import React, {useState, useEffect } from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { getUserData } from "./redux/slice/userSlice";

// const ProtectedRoute = () => {
//   const [data , setData] = useState(null)
//   const dispatch = useDispatch();
//   const loggedInUser = localStorage.getItem("user");
//   const user = JSON.parse(loggedInUser);
//   const { user_data, loading } = useSelector((state) => state.user);
// const
//   useEffect(() => {
//     if (user?.userid) {
//       dispatch(getUserData(user.userid));
//      setData(user)
//     }
//   }, [ ]);

//   if (!data) return <div>Loading...</div>;
// console.log(data)
//   if (!data || Object.keys(data).length === 0) {
//     return <Navigate to="/login" replace />;
//   }

//   return <Outlet />;
// };

// export default ProtectedRoute;
import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loggedInUser = localStorage.getItem("user");
    const user = JSON.parse(loggedInUser);

    if (!user?.userid) {
      setLoading(false);
      setUserData(null);
      return;
    }

    const fetchUser = async () => {
      try {
        const body = new FormData();
        body.append("action", "listbyid");
        // body.append("id", user.userid);

        const response = await fetch(
          "https://security.insugo.in/api/profile.php",
          {
            method: "POST",
            credentials: "include",
            body: body,
          }
        );
        const res = await response.json();

        // Handle session expired or invalid user
        if (
          !res.success ||
          !res.message ||
          Object.keys(res.message).length === 0 ||
          res.message === "Session Expired" ||
          res.message === "Session expired"
        ) {
          localStorage.removeItem("user");
          localStorage.removeItem("fbToken");
          setUserData(null);
        } else {
          setUserData(res.message);
        }
      } catch (error) {
        setUserData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (!userData) return <Navigate to="/login" replace />;
  return <Outlet />;
};

export default ProtectedRoute;
